import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./assets/styles/App.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__